var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-caption text-primary"},[_vm._v("Powered by "),_c('a',{attrs:{"href":"https://gitlab.com/action-lab-aus/bicara/zoomsense-tops"}},[_vm._v("Bicara")]),_vm._v(" · Code licenced under MIT · Content licensed under Creative Commons BY 4.0 · v"+_vm._s(_vm.version))])
}
var staticRenderFns = []

export { render, staticRenderFns }